export default __webpack_public_path__ + "static/small-9-6d67e83d68e0d5952195c5e5fee404a4.png";